import axiosInstance from "./service-instance";

import { createUrl } from "utilities";
import { CONTENT_TYPES } from "constants";


export default {
    caseLookup: (type, string) =>
        axiosInstance.get(createUrl(["case", "search"]), {
            params: {
                type: type,
                search: string
            },
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        })
};
